import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShieldAlt,
  faHeadset,
  faSchool,
  faChalkboardTeacher,
  faChartLine,
  faCalendarAlt,
} from '@fortawesome/free-solid-svg-icons';

import bgImage from '../../Assets/Images/CaseStudy/honeyc.jpg';

const WhyGlobalSolutions = () => {
  return (
    <section
      className="relative py-16 bg-cover bg-center bg-no-repeat overflow-hidden"
      style={{
        backgroundImage: `url(${bgImage})`,
        maskImage:
          'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
        WebkitMaskImage:
          'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
      }}
    >
      <div className="absolute inset-0 bg-white bg-opacity-80 z-0"></div>

      <div className="container relative z-10 mx-auto px-4">
        <h2 className="Headers font-ui">
          Why Choose Global Solutions?
        </h2>
        <p className="subHeads font-ui">
          We're not just another ERP provider. We're your partner in educational excellence with proven expertise and unwavering commitment to your success.
        </p>

        {/* Added container for cards with max-width */}
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-10 gap-10">
            {[
              {
                icon: faShieldAlt,
                title: '99.9% Uptime Guarantee',
                desc: 'Bank-grade security with 24/7 monitoring and automatic backups.',
              },
              {
                icon: faHeadset,
                title: '24/7 Expert Support',
                desc: 'Dedicated support team available round the clock via phone, chat, and email.',
              },
              {
                icon: faSchool,
                title: 'Multi-Campus Management',
                desc: 'Centralized control across multiple campuses with role-based access.',
              },
              {
                icon: faChalkboardTeacher,
                title: 'Free Training & Onboarding',
                desc: 'Comprehensive training programs for administrators and staff at no extra cost.',
              },
              {
                icon: faChartLine,
                title: 'Advanced Analytics',
                desc: 'AI-powered insights and predictive analytics for strategic decision making.',
              },
              {
                icon: faCalendarAlt,
                title: '10+ Years Experience',
                desc: 'Proven track record serving educational institutions across India.',
              },
            ].map(({ icon, title, desc }, i) => (
              <div
                key={i}
                className="relative bg-white border-2 border-amber-500 rounded-xl shadow-sm p-6 pt-10 text-center transition-all duration-300 hover:scale-[1.02] hover:shadow-lg"
              >
                {/* Floating Icon */}
                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-amber-100 border-2 border-white shadow-md">
                    <FontAwesomeIcon icon={icon} className="text-amber-500 w-6 h-6" />
                  </div>
                </div>

                {/* Content */}
                <div className="mt-10">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{title}</h3>
                  <p className="text-gray-600 font-ui leading-relaxed">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyGlobalSolutions;